import { StoreBase } from "../cutil/StoreBase";
export class ProjectStoreState {
    constructor() {
        this.attrIndexer = "";
    }
    copyWith(params) {
        const state = new ProjectStoreState();
        state.attrIndexer = params.attrIndexer ?? this.attrIndexer;
        return state;
    }
}
export class ProjectStore extends StoreBase {
    constructor() {
        super(() => new ProjectStoreState());
    }
    setAttrIndexer(attrIndexer) {
        const newState = this.state.copyWith({ attrIndexer });
        this.emit(newState);
    }
    get attrIndexer() {
        return this.state.attrIndexer;
    }
}
